import React from "react";

export function Card({ className = "", ...props }) {
  return (
    <div className={`rounded-2xl border bg-white shadow-sm ${className}`} {...props} />
  );
}

export function CardHeader({ className = "", ...props }) {
  return (
    <div className={`p-6 pb-0 ${className}`} {...props} />
  );
}

export function CardContent({ className = "", ...props }) {
  return <div className={`p-6 ${className}`} {...props} />;
}
